import styled from 'styled-components';

export const LegendItemContainer = styled.div`
    display: flex;
    height: 25px;
    // width: 165px;
    align-items: center;
    gap: 10px;
`;

export const ColorIndicator = styled.div`
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    border-radius: 50%;
    background-color: ${props => props.color};
`;

export const Label = styled.span`
    font-size: 14px;
    color: #333;
    // max-width: 140px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
`;

